import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import useSearch from "hooks/useSearch"
import MonitorDistributionListComponent from "components/MonitorReports/Distribution"
import {
  exportMonitorDistributionReport,
  getMonitorDistributionReports,
} from "store/monitor-reports/monitor-report-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorWarehouses,
} from "store/monitor-dashboard/monitor-dashboard-action"

const MonitorDistributionReportList = () => {
  document.title = "Distribution Reports"

  const dispatch = useDispatch()
  const distributions = useSelector(
    state => state.monitorReports.monitorDistributionsReport
  )
  const exportStatus = useSelector(
    state => state.monitorReports.monitorExportDistributionReport
  )
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(20)
  const [according, setAccording] = useState({ order: "desc", name: "date" })
  const [advnacedSearch, setAdvancedSearch] = useState({})

  const onSearchHandler = value => {
    setSearch(value)
  }

  const onPageClick = link => {
    dispatch(
      getMonitorDistributionReports(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  useSearch(
    getMonitorDistributionReports(
      undefined,
      undefined,
      undefined,
      search,
      advnacedSearch
    ),
    search
  )

  useEffect(() => {
    dispatch(
      getMonitorDistributionReports(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }, [pageNumber, according])

  useEffect(() => {
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorWarehouses())
    dispatch(getMonitorIps())
  }, [])

  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorDistributionReports(
        undefined,
        undefined,
        undefined,
        search,
        data
      )
    )
  }

  const onExportBtnClick = () => {
    dispatch(
      exportMonitorDistributionReport(
        pageNumber,
        according,
        search,
        advnacedSearch
      )
    )
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Distribution Report"} />
      <MonitorDistributionListComponent
        data={distributions?.data}
        error={distributions?.error}
        loading={distributions?.loading}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportTransaction={exportStatus}
        onPageClick={onPageClick}
      />
    </React.Fragment>
  )
}

export default MonitorDistributionReportList
